import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6100b640"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Settings", -1))
const _hoisted_2 = { class: "item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable sounds", -1))
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable chat messages", -1))
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = {
  key: 0,
  class: "item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accept challenges from", -1))
const _hoisted_10 = { class: "d-flex align-center challenge-btns" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Block all game challenges", -1))
const _hoisted_13 = { class: "d-flex align-center" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Block wager game challenges", -1))
const _hoisted_16 = { class: "d-flex align-center" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Hit position ball size", -1))
const _hoisted_19 = { class: "d-flex align-center challenge-btns" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Default practice game", -1))
const _hoisted_22 = { class: "d-flex align-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "POOL8" }, "8 Ball Pool", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "POOL9" }, "9 Ball Pool", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "POOL8UK" }, "8 Ball Pool UK", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "SNOOKER" }, "Regular Snooker", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "SNOOKER6" }, "6 Red Snooker", -1))
const _hoisted_28 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_switch = _resolveComponent("toggle-switch")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { onClose: _ctx.onClose }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_toggle_switch, {
            setting: 'enableSounds',
            checked: _ctx.settings.enableSounds,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => {_ctx.settings.enableSounds = $event;})
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_toggle_switch, {
            setting: 'enableChatMessages',
            checked: _ctx.settings.enableChatMessages,
            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.enableChatMessages = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      (!_ctx.isGuest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.acceptChallengesFrom = _ctx.acceptEveryone; _ctx.settings.acceptChallengesFrom = _ctx.acceptEveryone}),
                class: _normalizeClass([{ selected: _ctx.settings.acceptChallengesFrom === 'ACCEPT_EVERYONE' }, "btn"])
              }, " Everyone ", 2),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.acceptChallengesFrom = _ctx.acceptFriendsOnly; _ctx.settings.acceptChallengesFrom = _ctx.acceptFriendsOnly}),
                class: _normalizeClass([{ selected: _ctx.settings.acceptChallengesFrom === 'ACCEPT_FRIENDS_ONLY' }, "btn"])
              }, " Friends only ", 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_toggle_switch, {
            setting: 'blockAllGameChallenges',
            checked: _ctx.settings.blockAllGameChallenges,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => (_ctx.settings.blockAllGameChallenges = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_toggle_switch, {
            setting: 'blockWagerGameChallenges',
            checked: _ctx.settings.blockWagerGameChallenges,
            "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => (_ctx.settings.blockWagerGameChallenges = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.hitPositionSize = _ctx.smallBall; _ctx.settings.hitPositionSize = _ctx.smallBall}),
            class: _normalizeClass([{ selected: _ctx.settings.hitPositionSize === 'SMALL_BALL' }, "btn"])
          }, " Small ", 2),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.hitPositionSize = _ctx.largeBall; _ctx.settings.hitPositionSize = _ctx.largeBall}),
            class: _normalizeClass([{ selected: _ctx.settings.hitPositionSize === 'LARGE_BALL' }, "btn"])
          }, " Large ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("select", {
            class: "btn",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.defaultPracticeGame) = $event))
          }, _hoisted_28, 512), [
            [_vModelSelect, _ctx.settings.defaultPracticeGame]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}